import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsBasketAddNotice {
    /**
     * Block identifier
     */
    export const BLOCK_ID = 'basket-add-notice-modal';

    /**
     * Block cms data
     */
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    /**
     *  Block data content
     */
    export interface IBlockDataContent {
        /**
         * Modal title
         */
        title: string;
        /**
         * Button go to basket copy
         */
        buttonLabel: string;
        /**
         * Delivery message copy
         */
        deliveryText: string;
    }

    /**
     * Data passed to modal compoenent
     */
    export interface IModalData {
        basketItems: BasketItem[];
    }
}

@DfModal({
    id: NCmsBasketAddNotice.BLOCK_ID,
    name: 'Basket add notice modal (mobile only)',
    position: 'bottom',
    config: () => ({
        width: '100%',
        maxWidth: '100vw',
        position: {
            bottom: `0`
        },
        modalClass: 'p-a-0 bg-col-51'
    }),
    autoCreate: true,
    reopenPolicy: NDfModal.ReopenPolicy.both,
    sizeRestriction: sizeId => ({ S: ['S'], M: ['M'], L: [], X: [] })[sizeId],
    forbiddenLocation: /^\/(basket|checkout|success)$/
})
@ICmsComponent<BasketAddNoticeComponent>({
    id: NCmsBasketAddNotice.BLOCK_ID,
    block: {
        url: NCmsBasketAddNotice.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Basket add notice modal (mobile only)',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Added to your bag'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'buttonLabel',
            title: 'Button label',
            default: 'Review bag & checkout'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'deliveryText',
            title: 'Delivery Text',
            default: 'Order by 3pm for Next day delivery'
        }
    ]
})
@Component({
    selector: 'basket-add-notice',
    templateUrl: './basket-add-notice.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketAddNoticeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsBasketAddNotice.IBlockDataContent;

    constructor(
        @Inject(MODAL_DATA) private data: NCmsBasketAddNotice.IModalData,
        private modalRef: ModalRef<any>
    ) {
        super();
    }

    protected get basketItems() {
        return this.data?.basketItems;
    }

    protected close() {
        this.modalRef.close();
    }
}
